const formatBigMoney = (value: number | null): string => {
  if (value === null) return 'unknown';

  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
    notation: 'compact',
    compactDisplay: 'short',
  });
};

export default formatBigMoney;
